import React from 'react';
import { Outlet } from 'react-router-dom';

import { useAppSelector } from 'store/hook';
import { useDatadogRum } from 'utils/hooks/useDatadogRum';

const DatadogRumBoundary = () => {
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  useDatadogRum({
    user: currentUser
      ? {
          id: currentUser.manager ? String(currentUser.manager.id) : String(currentUser.user_id),
          email: currentUser.manager?.email ?? currentUser.email,
          name: currentUser.manager?.name ?? currentUser.name,
          groups: currentUser.manager ? undefined : currentUser.groups,
          is_admin: currentUser.manager ? currentUser.manager.is_superuser : currentUser.isSuperuser,
        }
      : null,
    impersonatedUser: currentUser?.manager
      ? {
          id: String(currentUser.user_id),
          email: currentUser.email,
          name: currentUser.name,
        }
      : null,
  });

  return <Outlet />;
};

export default DatadogRumBoundary;
